var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKbDesignerIcoPositiveHamburger40(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layout",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#f4f4f4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20,4c8.82,0,16,7.18,16,16s-7.18,16-16,16S4,28.82,4,20,11.18,4,20,4M20,2C10.06,2,2,10.06,2,20s8.06,18,18,18,18-8.06,18-18S29.94,2,20,2h0Z",
    fill: "#030303"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5,13.86h9.75M18.5,13.86c0,.83-.67,1.5-1.5,1.5s-1.5-.67-1.5-1.5M18.5,13.86c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5,1.5M11.75,13.86h3.75M18.5,25.86h9.75M18.5,25.86c0,.83-.67,1.5-1.5,1.5s-1.5-.67-1.5-1.5M18.5,25.86c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5,1.5M11.75,25.86h3.75M24.5,19.86h3.75M24.5,19.86c0,.83-.67,1.5-1.5,1.5s-1.5-.67-1.5-1.5M24.5,19.86c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5,1.5M11.75,19.86h9.75",
    fill: "none",
    stroke: "#030303",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKbDesignerIcoPositiveHamburger40);
export default __webpack_public_path__ + "static/media/kb-designer-ico-positive-hamburger_40.47ad7d0bc006167cb45e34e9098732e3.svg";
export { ForwardRef as ReactComponent };